import './App.css';
// import Navbar from './components/Navbar';
// import Home from './components/Home';
import HomePage from './components/HomePage';
import AboutUs from './components/About';
import INFO from './components/Info';
import Team from './components/Team';
import Testimonials from './components/Testimonials';
import ContactUs from './components/ContactUs';
import SignupText from './components/UserEngage';
import Footer from './components/Footer';
function App() {
  return (
    <div className="App">
      <section id="home"><HomePage/><br/></section>
      <section id="about"><AboutUs/></section>
      <INFO/>
      <Team/>
      <section id="services"><Testimonials/></section>
      <section id="contact"><ContactUs/></section>      
      <SignupText/>
      <Footer/>
      
    </div>
  );
}

export default App;
